module.exports = "<p>\n  You have successfully placed your order!\n</p>\n<div><a routerLink=\"/my/orders\" >View Orders </a></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shopping/components/order-success/order-success.component.html
// module id = ./src/app/shopping/components/order-success/order-success.component.html
// module chunks = main